import { MenuItem, Tooltip } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import { DragIndicator, OpenInFull, VisibilityOff } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import { CustomDivider } from '../styled';
import type { IHeaderActionMenu } from '../types';

export const Default = ({
  onOpenCard,
  hideHeader,
  handleClose,
  openReorderMenu,
  openCardLabel,
  hideHeaderTooltip,
  reorderDisabledTooltip,
  isReOrderingDisabled = false,
  isViewCardOptionDisabled,
}: IHeaderActionMenu) => {
  const { t } = useTranslation();
  const { isHeaderMenuDisabled, readOnly } = useSwimlaneRootProps();
  const isMenuDisabled = isHeaderMenuDisabled !== undefined ? isHeaderMenuDisabled : readOnly;

  const closeMenuAndOpenFieldCard = () => {
    onOpenCard();
    handleClose();
  };

  const closeMenuAndHideHeader = () => {
    hideHeader();
    handleClose();
  };

  // Intentionally not translated
  const disabledReorderTooltipMsgs = [
    'Reordering dates would upset the delicate balance of the universe. And your plans.',
    'You can plan around dates, but you can’t reorder them. This isn’t your personal time machine, Marty McFly.',
    'Reordering dates? Bold. But no.',
  ];

  const disabledReorderTooltipMsg = isReOrderingDisabled
    ? (reorderDisabledTooltip ??
      disabledReorderTooltipMsgs[Math.floor(Math.random() * disabledReorderTooltipMsgs.length)])
    : '';

  return (
    <>
      {!isViewCardOptionDisabled && (
        <>
          <MenuItem onClick={closeMenuAndOpenFieldCard} aria-label="open card" dense={true}>
            <ListItemIcon>
              <OpenInFull />
            </ListItemIcon>
            {openCardLabel}
          </MenuItem>
          <CustomDivider />
        </>
      )}
      <Tooltip title={disabledReorderTooltipMsg} placement="right" arrow>
        <span data-testid="disabled-reorder-tooltip">
          {/* span Needed so tooltip shows on disabled menu item */}
          <MenuItem
            onClick={openReorderMenu}
            aria-label="re-order menu"
            disabled={isMenuDisabled || isReOrderingDisabled}
            dense={true}
          >
            <ListItemIcon>
              <DragIndicator />
            </ListItemIcon>
            {t(($) => $.views.swimlane.headerMenu.reorderHeaders)}
          </MenuItem>
        </span>
      </Tooltip>
      <Tooltip title={hideHeaderTooltip} placement="right" arrow>
        <span data-testid={hideHeaderTooltip}>
          {/* span Needed so tooltip shows on disabled menu item */}
          <MenuItem
            onClick={closeMenuAndHideHeader}
            aria-label="hide header menu"
            disabled={isMenuDisabled || !!hideHeaderTooltip}
            dense={true}
          >
            <ListItemIcon>
              <VisibilityOff />
            </ListItemIcon>
            {t(($) => $.views.swimlane.headerMenu.hideHeader)}
          </MenuItem>
        </span>
      </Tooltip>
    </>
  );
};
